module.exports = __webpack_public_path__ + "error.ca6f212b.svg";